import React, { useState, useEffect, useRef, useMemo } from "react";
import DashNav from "../../Components/DashNav/DashNav";
import "./PublicationsAE.css";
import InputField from "../../Components/InputField/InputField";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import Gbtn from "../../Components/buttons/Gbtn";
import NewsPaper from "../../Components/SVGS/NewsPaper";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import { FcDocument } from "react-icons/fc";
import moment from "moment";
import validator from "validator";
import noImage from "../../Assests/avatar1.png";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import { deletePublication, getAllAuthors, postPublication } from "../../api";
import { Document, Page, pdfjs } from "react-pdf";
import "react-datepicker/dist/react-datepicker.css";

function PublicationsAE({ isEdit, isDelete }) {
  const icon = () => {
    return <NewsPaper size="26" height="30" fill="#DF2F35" />;
  };

  const location = useLocation();
  const publicationsObj =
    location.state && location.state ? location.state.publicationsToEdit : "";
  const page = location.state && location.state ? location.state.page : null;

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [today, setToday] = useState();
  const [isLoading, setIsLoading] = useState(false);
  let [profileImage, setProfileImage] = useState("");
  let [editImage, setEditImage] = useState("");
  let [uploadedDoc, setUploadedDoc] = useState("");
  const [editDoc, setEditDoc] = useState("");
  const [isErr, setIsErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [docErr, setDocErr] = useState(false);
  const [titleErr, settitleErr] = useState(false);
  const [abstractErr, setabstractErr] = useState(false);
  const [overviewErr, setoverviewErr] = useState(false);
  const [authorsErr, setauthorsErr] = useState(false);
  const [imageInputErr, setimageInputErr] = useState(false);
  const [imageErr, setImageErr] = useState(false);
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [allAuthor, setAllAuthor] = useState([]);
  const [authorOpt, setAuthorOpt] = useState([]);
  let [thumbnailType, setthumbnailType] = useState(
    isDelete || isEdit ? true : false
  );
  const [authors, setAuthors] = useState([]); //this is authors
  const [selectedAuthors, setSelectedAuthors] = useState([]);
  const [publication, setPublication] = useState({
    id: publicationsObj !== null && publicationsObj.id ? publicationsObj.id : 0,
    title: publicationsObj ? publicationsObj.title : "",
    published_date: publicationsObj ? publicationsObj.published_date : "",
    overview: publicationsObj ? publicationsObj.overview : "",
    abstract_link: publicationsObj
      ? publicationsObj.abstract_link
        ? publicationsObj.abstract_link
        : ""
      : "",
    image_path: publicationsObj ? publicationsObj.image_path : "",
    document_path: publicationsObj ? publicationsObj.document_path : "",
    author_publication: publicationsObj
      ? publicationsObj.author_publication
      : [],
  });
  const [dateObj, setDateObj] = useState({
    start_year: "2023",
    start_month: "01",
    start_day: "01",
  });

  useEffect(() => {
    getAllAuthors(100, 1).then(({ data }) => {
      if (data.error_code == 0) setAllAuthor(data.result);
    });
    setEditDoc(
      publicationsObj
        ? publicationsObj.document_path == "null"
          ? ""
          : publicationsObj.document_path
        : ""
    );
    setEditImage(publicationsObj ? publicationsObj.image_path : "");
  }, []);

  useEffect(() => {
    if (publicationsObj && publicationsObj.author_publicaton) {
      const selectedAuthorIds = publicationsObj.author_publicaton.map(
        (author) => author.author_id
      );
      setSelectedAuthors(selectedAuthorIds);
    }
  }, [publicationsObj]);

  useEffect(() => {
    setOptions();
  }, [allAuthor]);

  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);

  const navigate = useNavigate();

  const handleImgErr = (e) => {
    e.target.onerror = null;
    e.target.src = noImage;
  };

  const setOptions = () => {
    let arr = [];
    let arr2 = [];
    for (let index = 0; index < allAuthor.length; index++) {
      const element = allAuthor[index];
      let obj = {
        value: element.id,
        label: [
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={baseUrl + element.image_path}
              alt=""
              onError={handleImgErr}
              height={"24"}
              width={"24"}
              style={{
                borderRadius: "100%",
                marginRight: "10px",
                marginTop: "5px",
                border: "1px solid lightgray",
                overflow: "hidden",
              }}
            />
            {element.name.length > 23
              ? element.name.substring(0, 23)
              : element.name}
          </div>,
        ],
        // label: element.name,
      };
      arr.push(obj);
    }
    setAuthorOpt(arr);
  };
  const getDateToday = () => {
    const date = new Date();

    let currentDay = String(date.getDate()).padStart(2, "0");

    let currentMonth = String(date.getMonth() + 1).padStart(2, "0");

    let currentYear = date.getFullYear();

    return `${currentYear}-${currentMonth}-${currentDay}`;
  };
  useEffect(() => {
    setToday(getDateToday());
  }, []);

  const addOnclick = (e) => {
    e.preventDefault();
    publication.published_date = getPublishDate();
    let arr = [];
    for (let index = 0; index < selectedAuthors.length; index++) {
      const element = selectedAuthors[index];
      let obj = { author_id: element };
      arr.push(obj);
    }

    if (arr.length !== 0) publication.author_publication = arr;

    if (
      publication.abstract_link &&
      publication.abstract_link !== "" &&
      !validate(publication.abstract_link)
    ) {
      setIsValidUrl(false);
      setabstractErr(false);
      settitleErr(false);
    }

    // if (publication.title === "") {
    //   settitleErr(true);
    // } else if (publication.abstract_link === "") {
    //   settitleErr(false);
    //   setIsValidUrl(true);
    //   setabstractErr(true);
    // }
    // else if (!validate(publication.abstract_link)) {
    //   setIsValidUrl(false);
    //   setabstractErr(false);
    //   settitleErr(false);
    // } else if (publication.overview === "") {
    //   setabstractErr(false);
    //   settitleErr(false);
    //   setIsValidUrl(true);
    //   setoverviewErr(true);
    // } else if (selectedAuthors.length === 0) {
    //   setoverviewErr(false);
    //   setIsValidUrl(true);
    //   setabstractErr(false);
    //   settitleErr(false);
    //   setauthorsErr(true);
    //}
    // else if (editDoc === "" && uploadedDoc === "") {
    //   setoverviewErr(false);
    //   setabstractErr(false);
    //   settitleErr(false);
    //   setauthorsErr(false);
    //   setDocErr(true);
    // }
    // else if (editImage === "" && profileImage === "") {
    //   setDocErr(false);
    //   setimageInputErr(true);
    // }
    else {
      setoverviewErr(false);
      setabstractErr(false);
      settitleErr(false);
      setauthorsErr(false);
      setDocErr(false);
      setimageInputErr(false);
      setIsErr(false);
      let data = new FormData();
      data.append("id", publication.id);
      data.append("title", publication.title);
      if (publication.published_date != null) {
        data.append(
          "published_date",
          `${moment(publication.published_date).format("YYYY-MM-DD hh:mm:ss")}`
        );
      }
      data.append("overview", publication.overview);
      data.append("abstract_link", publication.abstract_link);
      if (typeof profileImage == "string") data.append("image_path", editImage);
      else data.append("image", profileImage, profileImage.name);
      // if (typeof uploadedDoc == "string") data.append("document_path", editDoc);
      if (!uploadedDoc) data.append("document_path", !editDoc ? null : editDoc);
      else data.append("document", uploadedDoc, uploadedDoc.name);

      let authors = publication.author_publication
        ? publication.author_publication
        : [];
      for (let i = 0; i < authors.length; i++) {
        var authorPublication = authors[i];
        data.append(`author_publication[${i}].id`, 0);
        data.append(
          `author_publication[${i}].author_id`,
          authorPublication.author_id
        );
        data.append(`author_publication[${i}].publication_id`, publication.id);
      }
      if (authors.length === 0) {
        data.append(`author_publication`, null);
      }

      setIsLoading(true);
      postPublication(data)
        .then(({ data }) => {
          setIsLoading(false);
          if (data.success) {
            navigate("/dashboard/publications", {
              state: { page: page },
            });
          } else {
            setIsErr(true);
            setErrMsg(data.message);
          }
        })
        .catch((err) => {
          console.log("publication post axios err", err);
          setIsErr(true);
          setIsLoading(false);
          setErrMsg(err.message);
        });
    }
  };
  const deleteOnclick = (e) => {
    e.preventDefault();
    setModalIsOpen(true);
  };

  const deleteClick = () => {
    let obj = {
      id: publicationsObj ? publicationsObj.id : null,
    };
    setIsLoading(true);
    deletePublication(obj)
      .then(({ data }) => {
        setIsLoading(false);
        setModalIsOpen(false);
        if (data.success) {
          navigate("/dashboard/publications", {
            state: { page: page },
          });
        } else {
          setIsErr(true);
          setErrMsg(data.message);
        }
      })
      .catch((err) => {
        console.log("delete axios error", err);
        setIsErr(true);
        setModalIsOpen(false);
        setIsLoading(false);
      });
  };

  const discardOnclick = () => {
    navigate("/dashboard/publications", {
      state: { page: page },
    });
  };

  const onSelectImage = (img) => {
    if (
      img.type.includes("png") ||
      img.type.includes("jpg") ||
      img.type.includes("jpeg")
    ) {
      setProfileImage(img);
      setImageErr(false);
      setEditImage("");
    } else {
      alert("Invalid File!");
    }
  };

  const onSelectDoc = (docc) => {
    if (!docc.type.includes("pdf")) setthumbnailType((thumbnailType = true));
    if (
      docc.type.includes("pdf") ||
      docc.type.includes("ppt") ||
      docc.type.includes("doc") ||
      docc.type.includes("docx")
    ) {
      setUploadedDoc((uploadedDoc = docc));
      setEditDoc("");
      if (docc.type.includes("pdf")) getPdfImg();

      setDocErr(false);
    } else alert("Invalid field");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPublication({ ...publication, [name]: value });
  };

  const handleImageErr = () => {
    setImageErr(true);
    setEditImage("");
    setProfileImage("");
  };

  const validate = (val) => {
    if (validator.isURL(val))
      // setIsValidUrl(true)
      return true;
    else setIsValidUrl(false);
    return false;
  };

  const selectRef = useRef(null);

  const handleBlur = () => {
    // Reset Select input when blurred
    selectRef.current.blur();
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownOpen = () => {
    setIsDropdownOpen(true);
  };

  const handleDropdownClose = () => {
    // setIsDropdownOpen(false);
  };

  const handleRemoveDocument = () => {
    setUploadedDoc("");
    setProfileImage("");
    setEditImage("");
    setEditDoc("");
    setthumbnailType(false);
    setEditDoc("");
  };

  const getPdfImg = () => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

    if (uploadedDoc) {
      try {
        const fileReader = new FileReader();
        fileReader.onload = async () => {
          const arrayBuffer = fileReader.result;
          const pdfData = new Uint8Array(arrayBuffer);

          // Load the PDF using react-pdf
          const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
          const page = await pdf.getPage(1);
          // Convert the page to an image
          const viewport = page.getViewport({ scale: 1 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: context, viewport }).promise;

          // const imageData = canvas.toDataURL();
          canvas.toBlob((blob) => {
            // Create a File object from the Blob (optional, for compatibility with file inputs)
            const file = new File([blob], "first_page.png", {
              type: "image/png",
            });

            // You can do whatever you want with the File object or Blob here
            setProfileImage(file);
          }, "image/png");
          // setImageData(imageData);
        };
        fileReader.readAsArrayBuffer(uploadedDoc);
      } catch (error) {
        console.error("Error processing the PDF:", error);
      }
    }
  };

  const thumbnail = useMemo(() => {
    if (uploadedDoc && uploadedDoc.type === "application/pdf") {
      return (
        <Document file={URL.createObjectURL(uploadedDoc)}>
          <Page pageNumber={1} />
        </Document>
      );
    } else {
      return publicationsObj.image_path &&
        publicationsObj.image_path !== "" &&
        isEdit ? (
        <img
          src={baseUrl + publicationsObj.image_path}
          height={"100%"}
          width={"100%"}
          alt="Document Thumbnail"
        />
      ) : null;
    }
  }, [uploadedDoc]);

  function handleDateSearch(e) {
    const { name, value } = e.target;
    setDateObj({ ...dateObj, [name]: value });
  }
  function getPublishDate() {
    let start_date =
      dateObj.start_year + "/" + dateObj.start_month + "/" + dateObj.start_day;

    start_date = moment(start_date).format("YYYY-MM-DD hh:mm:ss");
    return start_date;
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        className="deleteModal animate__animated animate__zoomIn"
        style={{ display: "flex" }}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div
              className="delClient-cross"
              onClick={(e) => {
                setModalIsOpen(false);
              }}
            >
              <RxCross2 color="white" size={"20"} />
            </div>
            <>
              <h3 style={{ color: "white", marginBottom: "60px" }}>
                Are you sure you want to delete?
              </h3>

              <Gbtn
                text="Delete"
                color="#EE282E"
                radius="6px"
                width="40%"
                func={deleteClick}
              />
            </>
          </>
        )}
      </Modal>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText={"Publications"} />
        </div>
        <form
          onSubmit={isDelete ? deleteOnclick : addOnclick}
          className="dashPanel ae-formArea"
        >
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <LoadingSpinner />
            </div>
          ) : (
            <div className="ae-form">
              <div className="err" style={{ display: isErr ? "flex" : "none" }}>
                Error! {errMsg}
              </div>
              <div className="ae-formFields">
                <div className="ae-inputField">
                  <InputField
                    cat="Title"
                    isErr={titleErr}
                    errorMsg="Title is required"
                    name={"title"}
                    value={publicationsObj ? publicationsObj.title : ""}
                    onChange={(e) => {
                      settitleErr(false);
                      handleChange(e);
                    }}
                    placeholder="Enter title"
                  />
                </div>
                <div className="ae-inputField">
                  <InputField
                    cat="View Abstract"
                    name={"abstract_link"}
                    isErr={abstractErr || !isValidUrl}
                    errorMsg={
                      !isValidUrl
                        ? "Not a Valid URL"
                        : "Abstract Url is required"
                    }
                    value={publicationsObj ? publicationsObj.abstract_link : ""}
                    onChange={(e) => {
                      setabstractErr(false);
                      setIsValidUrl(true);
                      handleChange(e);
                    }}
                    placeholder="Abstract Url"
                  />
                </div>
              </div>
              <div className="ae-formFields" style={{ position: "relative" }}>
                <div className="ae-inputField">
                  <InputField
                    cat="Overview"
                    name={"overview"}
                    isErr={overviewErr}
                    errorMsg="Overview is required"
                    value={publicationsObj ? publicationsObj.overview : ""}
                    onChange={(e) => {
                      setoverviewErr(false);
                      handleChange(e);
                    }}
                    placeholder="short description"
                  />
                </div>
                {/* <div className="ae-inputField" style={{ position: "relative" }}>
                  <div className="ar-selectText">Authors</div>
                  <div>
                    <Select
                      options={authorOpt}
                      placeholder={"Authors"}
                      // isOpen={handleDropdownOpen}
                      blurInputOnSelect={handleDropdownClose}
                      className={`ae-select ae-select-height ${
                        isDropdownOpen ? "" : "scrollable-select"
                      } `}
                      isMulti
                      value={selectedAuthors.map((selectedAuthor) =>
                        authorOpt.find(
                          (author) => author.value === selectedAuthor
                        )
                      )}
                      onChange={(selectedOptions) => {
                        setauthorsErr(false);
                        const selectedAuthorIds = selectedOptions.map(
                          (option) => option.value
                        );
                        setSelectedAuthors(selectedAuthorIds);
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          //   backgroundColor: state.isFocused ? "white" : "#F5F6FA",
                          width: "310px",
                          border: `1px solid ${
                            authorsErr ? "red" : " lightgray"
                          }`,
                          borderColor: authorsErr ? "red" : "lightgray",
                          maxHeight: state.selectProps.menuIsOpen
                            ? "100px"
                            : "40px",
                          overflow: state.selectProps.menuIsOpen
                            ? ""
                            : "hidden",
                          marginRight: "0px",
                          borderRadius: "8px",
                          fontSize: "14px",
                          padding: "0px 13px",
                        }),
                      }}
                      menuPortalTarget={document.body} // Render the menu outside of Select component
                      ref={selectRef}
                      onBlur={handleDropdownClose}
                    />
                    <div
                      className="err-txt"
                      style={{
                        display: authorsErr ? "flex" : "none",
                        position: "absolute",
                        width: "150px",
                        bottom: "0px",
                      }}
                    >
                      Author is required
                    </div>
                  </div>
                </div> */}
                <div className="ae-inputField">
                  <div class="dropdown_block">
                    <div class="if-txt">Published Date</div>
                    <div class="datesearch_inputs">
                      <input
                        class="start_year"
                        name="start_year"
                        type="number"
                        max={new Date().getFullYear()}
                        min="1900"
                        placeholder="YYYY"
                        defaultValue={
                          publicationsObj && publicationsObj.published_date
                            ? moment(publicationsObj.published_date).format(
                                "YYYY"
                              )
                            : ""
                        }
                        onChange={handleDateSearch}
                        required
                      />

                      <input
                        class="start-month"
                        aria-label="Start Month"
                        name="start_month"
                        type="number"
                        min="1"
                        max="12"
                        placeholder="MM"
                        defaultValue={
                          publicationsObj && publicationsObj.published_date
                            ? moment(publicationsObj.published_date).format(
                                "MM"
                              )
                            : ""
                        }
                        onChange={handleDateSearch}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="ae-formFields">
                <div className="ae-inputField">
                  <div class="dropdown_block">
                    <div class="if-txt">Published Date</div>
                    <div class="datesearch_inputs">
                      <input
                        class="start_year"
                        name="start_year"
                        type="number"
                        max={new Date().getFullYear()}
                        min="1900"
                        placeholder="YYYY"
                        defaultValue={
                          publicationsObj && publicationsObj.published_date
                            ? moment(publicationsObj.published_date).format(
                                "YYYY"
                              )
                            : ""
                        }
                        onChange={handleDateSearch}
                        required
                      />

                      <input
                        class="start-month"
                        aria-label="Start Month"
                        name="start_month"
                        type="number"
                        min="1"
                        max="12"
                        placeholder="MM"
                        defaultValue={
                          publicationsObj && publicationsObj.published_date
                            ? moment(publicationsObj.published_date).format(
                                "MM"
                              )
                            : ""
                        }
                        onChange={handleDateSearch}
                      />
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="ae-formFields">
                <div className="ae-inputField" style={{ position: "relative" }}>
                  <div className="ar-selectText" style={{ marginTop: "10px" }}>
                    Authors
                  </div>
                  <div>
                    <Select
                      options={authorOpt}
                      placeholder={"Authors"}
                      // isOpen={handleDropdownOpen}
                      blurInputOnSelect={handleDropdownClose}
                      className={`ae-select ae-select-height ${
                        isDropdownOpen ? "" : "scrollable-select"
                      } `}
                      isMulti
                      value={selectedAuthors.map((selectedAuthor) =>
                        authorOpt.find(
                          (author) => author.value === selectedAuthor
                        )
                      )}
                      onChange={(selectedOptions) => {
                        setauthorsErr(false);
                        const selectedAuthorIds = selectedOptions.map(
                          (option) => option.value
                        );
                        setSelectedAuthors(selectedAuthorIds);
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          //   backgroundColor: state.isFocused ? "white" : "#F5F6FA",
                          width: "310px",
                          border: `1px solid ${
                            authorsErr ? "red" : " lightgray"
                          }`,
                          borderColor: authorsErr ? "red" : "lightgray",
                          maxHeight: state.selectProps.menuIsOpen
                            ? "100px"
                            : "40px",
                          overflow: state.selectProps.menuIsOpen
                            ? ""
                            : "hidden",
                          marginRight: "0px",
                          borderRadius: "8px",
                          fontSize: "14px",
                          padding: "0px 13px",
                        }),
                      }}
                      menuPortalTarget={document.body} // Render the menu outside of Select component
                      ref={selectRef}
                      onBlur={handleDropdownClose}
                    />
                    <div
                      className="err-txt"
                      style={{
                        display: authorsErr ? "flex" : "none",
                        position: "absolute",
                        width: "150px",
                        bottom: "0px",
                      }}
                    >
                      Author is required
                    </div>
                  </div>
                </div>
              </div>

              <div className="files-inputs-container">
                <div className="file-input">
                  <div className="if-txt" style={{ marginTop: "40px" }}>
                    Upload PDF
                  </div>
                  <div
                    className="Add_Client_Image_container"
                    style={{ position: "relative" }}
                  >
                    {editDoc || uploadedDoc ? (
                      <>
                        <div
                          onClick={() =>
                            window.open(
                              uploadedDoc
                                ? URL.createObjectURL(uploadedDoc)
                                : baseUrl + publicationsObj.document_path,
                              "_blank"
                            )
                          }
                        >
                          <FcDocument size={"100%"} />
                        </div>

                        {editDoc || uploadedDoc ? (
                          <div
                            className="document-cross"
                            onClick={() => handleRemoveDocument()}
                          >
                            <RxCross2 size={15} color="white" />
                          </div>
                        ) : null}
                        <div>
                          <input
                            type="file"
                            className="formuploadimage_input"
                            accept=".pdf, .ppt,.pptx, .doc, .docx"
                            onChange={(e) => {
                              setDocErr(false);
                              onSelectDoc(e.target.files[0]);
                            }}
                            onClick={(event) =>
                              (event.currentTarget.value = null)
                            }
                          />
                        </div>
                      </>
                    ) : (
                      <label className="changeimage-label">
                        <div className="AddimageBtn">
                          <span className="cam_Image_upload">+</span>
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".pdf, .ppt,.pptx, .doc, .docx"
                              onChange={(e) => {
                                setDocErr(false);
                                onSelectDoc(e.target.files[0]);
                              }}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </div>
                      </label>
                    )}
                  </div>
                  <div
                    className="err-txt"
                    style={{
                      display: docErr ? "flex" : "none",
                      width: "150px",
                    }}
                  >
                    document is required
                  </div>
                </div>

                <div className="file-input">
                  {thumbnailType ? (
                    <div>
                      <div className="if-txt" style={{ marginTop: "40px" }}>
                        Add Image
                      </div>
                      <div className="Add_Client_Image_container">
                        <label className="changeimage-label">
                          {editImage || profileImage ? (
                            <>
                              <img
                                src={
                                  editImage
                                    ? baseUrl + editImage
                                    : URL.createObjectURL(profileImage)
                                }
                                onError={handleImageErr}
                                alt="cp"
                                height="120px"
                                width="120px"
                                className="add-image-Style"
                              />
                              <div>
                                <input
                                  type="file"
                                  className="formuploadimage_input"
                                  accept=".png, .jpg, jpeg"
                                  onChange={(e) =>
                                    onSelectImage(e.target.files[0])
                                  }
                                  onClick={(event) =>
                                    (event.currentTarget.value = null)
                                  }
                                />
                              </div>
                            </>
                          ) : (
                            <div className="AddimageBtn">
                              <span className="cam_Image_upload">+</span>
                              <div>
                                <input
                                  type="file"
                                  className="formuploadimage_input"
                                  accept=".png, .jpg, jpeg"
                                  onChange={(e) =>
                                    onSelectImage(e.target.files[0])
                                  }
                                  onClick={(event) =>
                                    (event.currentTarget.value = null)
                                  }
                                />
                              </div>
                            </div>
                          )}
                        </label>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="if-txt" style={{ marginTop: "40px" }}>
                        Thumbnail
                      </div>
                      <div className="thumbnail_container">{thumbnail}</div>
                    </div>
                  )}

                  <div
                    className="err-txt"
                    style={{
                      display: imageInputErr ? "none" : "none",
                      width: "150px",
                    }}
                  >
                    image is required
                  </div>
                </div>
              </div>
            </div>
          )}

          <div>
            <div className="ev-btnAdd ev-btn">
              <Gbtn
                text={isEdit ? "Update" : isDelete ? "Delete" : "Add"}
                // func={isDelete ? deleteOnclick : addOnclick}
                type="submit"
                disabled={isLoading}
                color={isLoading ? "#df2f35c4" : "#DF2F35"}
                radius="5px"
                width="160px"
              />
            </div>
            <div className="ev-btnDel ev-btn">
              <Gbtn
                func={discardOnclick}
                text="Discard"
                color="#0061B1"
                radius="5px"
                width="160px"
              />
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default PublicationsAE;
